<template>
  <Pie
    :options="computedChartOptions"
    :data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :width="width"
    :height="height"
    data-test-name="pie-chart"
    data-test-variant=""
    data-test-state=""
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { Pie } from 'vue-chartjs'
import * as ChartJS from 'chart.js'
import { cloneDeep, merge } from 'lodash-unified'
import { getChartDefaultOptions } from './utils'
import type { ChartData, ChartOptions, Plugin } from 'chart.js'
import type { PropType } from 'vue'

const { ArcElement, CategoryScale, Chart, Legend, Title, Tooltip } = ChartJS
Chart.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

defineOptions({ name: 'BPieChart' })

const props = defineProps({
  chartId: {
    type: String,
    default: 'pie-chart',
  },
  datasetIdKey: {
    type: String,
    default: 'label',
  },
  width: {
    type: Number,
    default: 240,
  },
  height: {
    type: Number,
    default: 240,
  },
  plugins: {
    type: Array as PropType<Plugin<'pie'>[]>,
    default: () => [],
  },
  chartData: {
    type: Object as PropType<ChartData<'pie', number[], unknown>>,
    default: () => ({ datasets: [] }),
  },
  chartOptions: {
    type: Object as PropType<ChartOptions<'pie'>>,
    default: () => ({ responsive: true, maintainAspectRatio: true }),
  },
})

const defaultOptions = cloneDeep(
  getChartDefaultOptions('pie')
) as ChartOptions<'pie'>

const computedChartOptions = computed(() =>
  merge(merge(defaultOptions, { cutout: '72%' }), props.chartOptions)
)
</script>
